import React from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import AboutHero from './components/AboutHero';
import MissionSection from './components/MissionSection';
import TeamSection from './components/TeamSection';
import StatsSection from './components/StatsSection';
import CertificationsSection from './components/CertificationsSection';

const About: React.FC = () => {
  return (
    <div className="min-h-screen bg-white" style={{ fontFamily: 'Inter, sans-serif' }}>
      <Header />
      <main>
        <AboutHero />
        <MissionSection />
        <StatsSection />
        <TeamSection />
        <CertificationsSection />
      </main>
      <Footer />
    </div>
  );
};

export default About;